import React, { useCallback, useEffect, useMemo } from 'react';
import Layout from './layout';
import ReactGA from 'react-ga4';
import { identifyUser } from './mixpanel';
import usePageTracking from './utils/usePageTracking';
import { endUserSession, startUserSession } from './utils/analyticsTracker';
import { useDispatch, useSelector } from 'react-redux';
import { IdleTimerProvider } from './constants/IdleTimerProvider';
import { logOutFromServer } from './redux/actions/auth-action';
import { toast } from 'react-toastify';
import { setIsLoggedIn } from './redux/reducers/auth-reducer';
import { ActionTypes } from './redux/type';
import { useNavigate } from 'react-router-dom';
ReactGA.initialize('G-ZK38JF4HN6');

const SESSION_MS = 12 * 60 * 60 * 1000;

const App = () => {
  // console.log = () => { }
  // console.warn = () => { }
  // console.error = () => { }
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userDetails } = useSelector((s: any) => s.auth.loginDetails);
  const { isLoggedIn } = useSelector((state: any) => state.auth);
  const allState = useSelector((state: any) => state);

  // Leave at once; the server call can take long when the API is busy.
  const handleLogout = () => {
    const details = allState?.auth?.loginDetails?.user_details?.[0];
    logOutFromServer({ refresh_token: details?.refresh_token }, details?.access_token);
    localStorage.removeItem("loginAt");
    dispatch(setIsLoggedIn(false));
    dispatch({ type: ActionTypes.GLOBAL_RESET, payload: undefined });
    endUserSession(userDetails);
    navigate("/");
    toast.success('Logout Successfully', {
      position: "top-right",
      autoClose: 3000,
      theme: "light"
    });
  };

  // The server ends a session 12 h after login (UserSession.expires_at), so
  // log out then. Comparing UTC dates logged people out the moment they
  // opened the portal after 05:30 IST, however recently they had signed in.
  useEffect(() => {
    if (!isLoggedIn) return;
    const check = () => {
      const loginAt = Number(localStorage.getItem("loginAt") || 0);
      if (loginAt && Date.now() - loginAt > SESSION_MS) handleLogout();
    };
    check();
    const id = setInterval(check, 60 * 1000);
    return () => clearInterval(id);
  }, [isLoggedIn]);

  const mockUser = useMemo(() => ({
    id: userDetails?.[0]?.userid,
    name: userDetails?.[0]?.username,
    email: userDetails?.[0]?.email,
  }), [userDetails]);

  const startSession = useCallback(() => {
    if (mockUser?.id && mockUser?.name) {
      identifyUser(mockUser);
      startUserSession(mockUser);
    }
  }, [mockUser]);

  useEffect(() => {
    startSession();
  }, [startSession]);

  const endSession = () => {
    endUserSession(userDetails);
  };

  usePageTracking(mockUser?.id ? mockUser : null);
  return (
    <div>
      <IdleTimerProvider
        onActive={startSession}
        onIdle={endSession}
      >
        <Layout />
      </IdleTimerProvider>
    </div>
  );
};

export default App; 